import React, { createContext, useReducer, useEffect } from 'react';
import FullCard from '../../../../../components/Card/FullCard';
import AddButtons from './AddButtons';
import FleetsTable from './FleetsTable';
import reducer, { initialState } from './reducer';
import Dialogs from './Dialogs/Dialogs';
import axios from '../../../../../api/axios';
import Progressbar from '../../../../../components/Progress/Progressbar';
import useTitle from 'hooks/useTitle';

export const store = createContext({});
const { Provider } = store;

const Fleets = ({ config }) => {
  useTitle('انواع ناوگان');
  const [state, dispatch] = useReducer(reducer, initialState);

  const getFleetsAndFleetOptions = async () => {
    const { data } = await axios.get(`/api/v1/admin/parameters/fleets/all`);
    dispatch({ type: 'SET_FLEETS_AND_FLEETOPTIONS', payload: data });
  };
  const doDeleteFleet = async (id) => {
    try {
      await axios.delete(`/api/v1/admin/parameters/fleets/${id}`);
      getFleetsAndFleetOptions();
    } catch (error) {
      console.error(JSON.stringify(error, null, 2));
    }
  };
  const doDeleteFleetOption = async (id) => {
    try {
      await axios.delete(`/api/v1/admin/parameters/fleets/fleetOption/${id}`);
      getFleetsAndFleetOptions();
    } catch (error) {
      console.error(JSON.stringify(error, null, 2));
    }
  };

  useEffect(() => {
    getFleetsAndFleetOptions();
  }, []);

  return (
    <Provider
      value={{
        state,
        dispatch,
        getFleetsAndFleetOptions,
        doDeleteFleet,
        doDeleteFleetOption,
      }}
    >
      <Dialogs />
      <FullCard
        title={config.name}
        category="افزودن و ویرایش انواع ناوگان و ویژگی آنها"
        actions={<AddButtons />}
      >
        {state.loading ? <Progressbar /> : null}
        <FleetsTable />
      </FullCard>
    </Provider>
  );
};

export default Fleets;
